var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { SetLabel, RemoveLabel } from 'src/app/story/state/labels/story.labels.actions';
import { LabelPinType } from 'src/app/story/models/labels/label-pin-type.enum';
import { LabelFlyTo } from 'src/app/story/models/labels/label-fly-to.enum';
import { CameraService } from 'src/app/engine/camera.service';
import { MatSnackBar } from '@angular/material';
import { LabelThemeEnum } from 'src/app/story/models/labels/label-theme.enum';
import { FlyToObjectErrandModel } from 'src/app/story/models/errands/fly-to-object-errand.model';
import { FlyToCameraErrandModel } from 'src/app/story/models/errands/fly-to-camera-errand.model';
import { LabelStateModel } from 'src/app/story/models/labels/label-state.model';
import { uuid } from 'src/app/shared/uuid';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { get, cloneDeep } from 'lodash';
var LabelWidgetComponent = /** @class */ (function () {
    function LabelWidgetComponent(formBuilder, store, cameraService, matSnackBar) {
        this.formBuilder = formBuilder;
        this.store = store;
        this.cameraService = cameraService;
        this.matSnackBar = matSnackBar;
        this.labelTheme = LabelThemeEnum;
        this.labelPinType = LabelPinType;
        this.labelFlyTo = LabelFlyTo;
        this.ngUnsubscribe = new Subject();
        this.open = false;
        this.opened = new EventEmitter();
        var defaultLabel = new LabelModel('');
        this.form = this.formBuilder.group({
            title: [defaultLabel.title],
            description: [defaultLabel.description],
            theme: [defaultLabel.theme],
            pinType: [defaultLabel.pinType, Validators.required],
            pinGlow: [defaultLabel.pinGlow],
            collapseDescription: [defaultLabel.collapseDescription],
            hideWire: [defaultLabel.hideWire],
            hideTag: [defaultLabel.hideTag],
            expandTag: [defaultLabel.expandTag],
            showDescription: [defaultLabel.showDescription],
            flyTo: [false],
            flyToTarget: [''],
        });
    }
    Object.defineProperty(LabelWidgetComponent.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (value) {
            var a = JSON.stringify(value);
            var b = JSON.stringify(this._label);
            if (a !== b) {
                this._label = value;
                this.setFormValues(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelWidgetComponent.prototype, "_theme", {
        get: function () {
            return this.form.get('theme').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelWidgetComponent.prototype, "_flyTo", {
        get: function () {
            return this.form.get('flyTo').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelWidgetComponent.prototype, "_flyToTarget", {
        get: function () {
            return this.form.get('flyToTarget').value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelWidgetComponent.prototype, "_hideWire", {
        get: function () {
            return this.form.get('hideWire').value;
        },
        enumerable: true,
        configurable: true
    });
    LabelWidgetComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (values) { return _this.handleFormChanges(values); });
    };
    LabelWidgetComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    LabelWidgetComponent.prototype.handleAlignButton = function (left, top) {
        this.label.offset = [left, top];
        this.store.dispatch(new SetLabel(this.label));
    };
    LabelWidgetComponent.prototype.handleRecordPositionClick = function () {
        this.label.states = this.prepareLabelStates(this.label.states);
        this.label.states[1].errands = [new FlyToCameraErrandModel(this.cameraService.getCamera())];
        this.store.dispatch(new SetLabel(this.label));
        this.matSnackBar.open('Recorded marked position');
    };
    LabelWidgetComponent.prototype.handleRemove = function () {
        this.store.dispatch(new RemoveLabel(this.label));
    };
    LabelWidgetComponent.prototype.handleFormChanges = function (values) {
        var label = cloneDeep(this.label);
        // On annotation theme, limit functionality
        if (values.theme === LabelThemeEnum.Annotation) {
            values.hideWire = false;
            values.pinType = LabelPinType.Default;
        }
        label.title = values.title;
        label.description = values.description || '';
        label.theme = values.theme;
        label.pinType = values.pinType;
        label.pinGlow = values.pinGlow;
        label.collapseDescription = values.collapseDescription;
        label.hideWire = values.hideWire;
        label.hideTag = values.hideTag;
        label.expandTag = values.expandTag;
        label.showDescription = values.showDescription;
        // Parse fly to functionality
        if (values.flyTo) {
            label.states = this.prepareLabelStates(label.states);
            label.flyTo = values.flyTo;
            label.flyToTarget = values.flyToTarget;
            switch (values.flyToTarget) {
                case LabelFlyTo.Object:
                    label.states[1].errands = [new FlyToObjectErrandModel(label.objectId)];
                    break;
                case LabelFlyTo.Position:
                    var errand = get(label, 'states[1].errands[0]');
                    if (!(errand instanceof FlyToCameraErrandModel)) {
                        label.states[1].errands = [new FlyToCameraErrandModel(this.cameraService.getCamera())];
                    }
                    break;
            }
        }
        else {
            if (label.states && label.states.length && label.states[1]) {
                label.states[1].errands = [];
            }
        }
        this.store.dispatch(new SetLabel(label));
    };
    LabelWidgetComponent.prototype.handleAlignClick = function (direction) {
        var label = cloneDeep(this.label);
        var amount = (label.hideWire) ? 20 : 32;
        switch (direction) {
            case 'left':
                label.offset = [-amount, 0];
                break;
            case 'right':
                label.offset = [amount, 0];
                break;
        }
        this.store.dispatch(new SetLabel(label));
    };
    LabelWidgetComponent.prototype.handleOpened = function (open) {
        this.opened.emit({
            label: this.label,
            open: open
        });
    };
    LabelWidgetComponent.prototype.prepareLabelStates = function (states) {
        var newStates = states ? __spread(states) : [];
        if (!newStates) {
            newStates = [];
        }
        if (!newStates[0]) {
            newStates[0] = new LabelStateModel();
            newStates[0].id = uuid.idWithPrefix('label-state');
        }
        if (!newStates[1]) {
            newStates[1] = new LabelStateModel();
            newStates[1].id = uuid.idWithPrefix('label-state');
        }
        return newStates;
    };
    LabelWidgetComponent.prototype.setFormValues = function (label) {
        var values = {
            title: label.title,
            description: label.description || '',
            theme: label.theme,
            pinType: label.pinType,
            pinGlow: label.pinGlow,
            collapseDescription: label.collapseDescription,
            hideWire: label.hideWire,
            hideTag: label.hideTag,
            flyTo: null,
            flyToTarget: LabelFlyTo.Object,
            expandTag: label.expandTag,
            showDescription: label.showDescription
        };
        // Wire up fly to
        var errand = get(label, 'states[1].errands[0]');
        if (errand) {
            values.flyTo = true;
            switch (true) {
                case errand instanceof (FlyToCameraErrandModel):
                    values.flyToTarget = LabelFlyTo.Position;
                    break;
                case errand instanceof (FlyToObjectErrandModel):
                default:
                    values.flyToTarget = LabelFlyTo.Object;
                    break;
            }
        }
        this.form.setValue(values, { emitEvent: false });
    };
    return LabelWidgetComponent;
}());
export { LabelWidgetComponent };
